import React from "react";
import {connect} from "react-redux";
import {GoogleRecaptchaV3} from "../../app-config";
import {loadReCaptcha, ReCaptcha} from "react-recaptcha-v3";
import {setRecaptchaAction} from "../../redux/actions/setRecaptchaAction";
import './styles.css';

/**
 * This class is used to generate google reCaptcha v3 component for this system.
 * By using redux, we store reCaptcha value, unauthorized reference, authorized reference and reference in Splash screen (to call get_public_config)
 * For pages in unauthorized mode, we use refUnauthorized as reference to this component, so we can use that references to call execute() method to renew reCaptcha value.
 * For other modes including authorized and splashing, it works in the same way.
 * Once VccRecaptcha is "did mount', it will generate a new reCaptcha value then that value will be set on redux (recaptcha attribute).
 *
 * @property setRecaptchaAction (method): To set the generated reCaptcha and save it in the Redux.
 * @property onHasTokenCallback (method): This callback will be executed once this Component gets a new token. Normally, this callback is referred to the caller component's function.
 * @property vccRef (props): To work as reference to call execute() method to get a new token if needed. It should be refUnauthorized, refAuthorized or refSplash only.
 */
class VccRecaptcha extends React.Component {

    constructor(props) {
        super(props);
        // this.recaptchaRef = React.createRef();
        this.recaptchaCallback = this.recaptchaCallback.bind(this);
    }

    recaptchaCallback = (token) => {
        this.props.setRecaptchaAction({...this.props.recaptcha, recaptcha: token});
        if ((typeof this.props.onHasTokenCallback) === "function") {
            this.props.onHasTokenCallback(token);
            //this.props.recaptcha.refSplash.current.execute()
        }
    };

    componentDidMount() {
        loadReCaptcha(GoogleRecaptchaV3.RECAPTCHA_PUBLIC_KEY);
    }


    render() {
        return (
            <ReCaptcha ref={this.props.vccRef}
                       sitekey={GoogleRecaptchaV3.RECAPTCHA_PUBLIC_KEY}
                       action='loading'
                       verifyCallback={this.recaptchaCallback}
            />
        )
    }
}

function mapState2Props(state) {
    return {
        recaptcha: state.recaptcha
    }
}

export default connect(mapState2Props, {
    setRecaptchaAction
})(VccRecaptcha);
